import {ObjectUtil} from '../../util/object-util';

export class CompactOffer {

  amountCovered: number = null;
  premium: number = null;
  expectedTotalPremium: number = null;
  advancePremium: number = null;
  minimumPremium: number = null;
  currency: string = null;
  isLeading: boolean = null;
  companyName: string = null;

  standardTermsAndConditions: string[] = [];
  individualTermsAndConditions: string = null;
  standardClauses: string[] = [];
  individualClauses: string = null;

  deductibleAbsoluteAmount: number = null;
  deductibleCurrency: string = null;
  typeOfDeductible: string = null;
  referenceValue: string = null;

  constructor(object?: Object) {
    ObjectUtil.assign(this, object);
  }

  // compact offer may only contain parts which are visible for all
  // in that case the backend will send an incomplete compact offer
  get isComplete() {
    return this.amountCovered != null;
  }
}
